import { Injectable } from '@angular/core';
import { select } from '@ngrx/store';
import { BaseStore } from './base-store';
import { Observable } from 'rxjs';
import {
	getVehiclesDetailsHasSuccess,
	getVehiclesDetailsHasError,
	getVehiclesDetailsIsLoading,
	getVehiclesDetailsMessage
} from '@shared/store/selectors';

@Injectable()
export class VehiclesDetailsStore extends BaseStore {
	get hasSuccess(): Observable<boolean> {
		return this.store.pipe(select(getVehiclesDetailsHasSuccess));
	}
	get hasError(): Observable<boolean> {
		return this.store.pipe(select(getVehiclesDetailsHasError));
	}
	get isLoading(): Observable<boolean> {
		return this.store.pipe(select(getVehiclesDetailsIsLoading));
	}
	get message(): Observable<string | null> {
		return this.store.pipe(select(getVehiclesDetailsMessage));
	}
}
